import CollapsibleText from './CollapsibleText'

export default CollapsibleText
